import { generateSSE } from "../utils/sse";

import { type SSEConfig } from "../types/sse";

import { LocalStorage } from "../utils/localStorage";

import { store } from "../redux/store";

export const sse = generateSSE<SSEConfig>(
   {
      baseUrl: import.meta.env.VITE_API_URL,
      getHeaders: {
         Authorization: () => {
            const cashedFirebaseUserIdToken = LocalStorage.getItem("firebaseUserIdToken");
            const firebaseUserIdToken = store.getState().user.firebaseUserIdToken;

            return firebaseUserIdToken || cashedFirebaseUserIdToken
               ? `Bearer ${firebaseUserIdToken || cashedFirebaseUserIdToken}`
               : undefined;
         },
      },
   },
   {
      getListingProcessingById: {
         path: "/listing-processing",
         includeHeaders: ["Authorization"],
         eventName: "status",
      },
   },
);
